import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Grid,
  Autocomplete,
  TextField,
} from "@mui/material";

import PageContainer from "src/components/container/PageContainer";
import DashboardCard from "src/components/shared/DashboardCard";
import { useSnackBar } from "src/context/SnackBarContext";
import DataTable from "src/components/DataTable";
import Loader from "src/components/Loader";
import { postData } from "../utilities/api";
import useFetchData from "../utilities/useFetchData";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";

const paymentModes = ["Cash", "UPI", "Bank", "Card"];

const columns = [
  { field: "BillNo", headerName: "Bill No", width: 100 },
  { field: "Party", headerName: "Party", flex: 1 },
  { field: "Item", headerName: "Item", flex: 1 },
    { field: "note", headerName: "Variant", flex: 1 },
    { field: "unit", headerName: "Type", flex: 1 },


  // { field: "Discount", headerName: "Discount", flex: 1 },
  // { field: "Rate", headerName: "Rate", flex: 1 },
  { field: "Qty", headerName: "Qty", flex: 1 },
  // { field: "net_total", headerName: "Total", flex: 1 },
  // { field: "Received", headerName: "Received", flex: 1 },
  // { field: "PaymentMode", headerName: "Payment Mode", flex: 1 },
  { field: "exp_date", headerName: "Delivery Date", flex: 1 , renderCell: (params) => {
        const formattedDate = dayjs(params.exp_date).format("DD/MM/YYYY");
        return <span>{formattedDate}</span>;
      },},
];

function DeliveryReport() {
  const { showSnackbar } = useSnackBar();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());

  const [selectedParty, setSelectedParty] = useState(null);
  const [selectedMode, setSelectedMode] = useState("");
  const [selectedType, setSelectedType] = useState("Qoutation");
  const [selectedItem, setSelectedItem] = useState({productName:"ALL"});
  const [selectedItemType, setSelectedItemType] = useState({main_sect:"ALL"});




  const { data, isLoading, error } = useFetchData(
    ["masterData","productData","itemTypes"],
    ["/api/getMasterDatas","/api/getProducts","/api/getAdminMastersStatic"]
  );
  const partyData = data?.masterData?.data || [];
  const itemTypes=data?.itemTypes?.data || [];
  console.log(itemTypes);
  
  const navigate = useNavigate();
  // console.log(partyData, isLoading, error);
  
  const navigateToPrint = (type) => {
    navigate("/delivery_report_print", {
      state: {
        header: {
          fromDate: dayjs(fromDate).format("DD/MM/YYYY"),
          toDate: dayjs(toDate).format("DD/MM/YYYY"),
          party: selectedParty,
          // branch: selectedBranch,
        },
        table: reportData,
        type: type,
      },
    });
  };
  const handleDateChange = (from, to) => {
    setFromDate(from);
    setToDate(to);
  };

  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      // branch: selectedBranch,
      party: selectedParty,
      paymentMode: selectedMode,
      fromDate: fromDate || dayjs(),
      toDate: toDate || dayjs(),
      type:selectedType,
      itemType:selectedItemType.main_sect,
      item:selectedItem.productName
    };

    const result = await postData("/api/getDeliveryReport", payload);

    if (!result.success) {
      showSnackbar("error", result.message);
      setReportData([]);
    } else if (result.data?.length === 0) {
      showSnackbar("warning", "No data found");
      setReportData([]);
    }else {
    
      const dataWithSi = result.data.map((row, index) => {
        let updatedReceiptType = row.PaymentMode;
    
        // Check for cash and received 0, set to "Pending"
        if (row.PaymentMode === "Cash" && row.Received === 0) {
          updatedReceiptType = "Pending";
          console.log("Pending", row.Received, row.PaymentMode);
          
        }
       
        return {
          si: index + 1,
          ...row,
          PaymentMode: updatedReceiptType,
        };
      });
    
      setReportData(dataWithSi);
    }

    setLoading(false);
  };

  return (
    <>
      <Loader start={loading || isLoading} />
      <PageContainer>
        <DashboardCard>
          <Typography variant="h4" mb={2}>
            Delivery Report
          </Typography>

          <Box sx={{ mt: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                  <DatePicker
                    label="From Date"
                    format="DD/MM/YYYY"
                    value={fromDate}
                    onChange={(date) => setFromDate(date)}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <DatePicker
                    label="To Date"
                    format="DD/MM/YYYY"
                    minDate={fromDate}
                    value={toDate}
                    onChange={(date) => setToDate(date)}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                  />
                </Grid>
                  <Grid item xs={12} md={4}>
                <Autocomplete
                  options={[{productName:"ALL"}].concat(data?.productData?.data || [])}
                  getOptionLabel={(option) => option.productName}
                  value={selectedItem}
                  onChange={(e, val) =>
                    setSelectedItem(val)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Item"
                      size="small"
                      fullWidth
                    />
                  )}
                />
                
              </Grid>
                  

                {/* <Grid item xs={12} md={4}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={["ALL", ...(partyData?.branch_list || [])]}
                    value={selectedBranch || "ALL"}
                    getOptionLabel={(option) => {
                      if (typeof option === "string") return option;
                      return `${option.label || ""}`.trim();
                    }}
                    isOptionEqualToValue={(option, value) => {
                      if (
                        typeof option === "string" ||
                        typeof value === "string"
                      ) {
                        return option === value;
                      }
                      return (
                        option.label === value.label &&
                        option.name === value.name
                      );
                    }}
                    onChange={(e, val) =>
                      setSelectedBranch(val === "ALL" ? null : val)
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Branch" />
                    )}
                  />
                </Grid> */}
              </Grid>
            </LocalizationProvider>

            {/* Remaining Grid for Party, Payment Mode, Submit Button */}
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={["ALL", ...(partyData?.customer_list || [])]}
                  value={selectedParty || "ALL"}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") return option;
                    return `${option.label}-${option.name || ""}`.trim();
                  }}
                  isOptionEqualToValue={(option, value) => {
                    if (
                      typeof option === "string" ||
                      typeof value === "string"
                    ) {
                      return option === value;
                    }
                    return (
                      option.label === value.label && option.name === value.name
                    );
                  }}
                  onChange={(e, val) =>
                    setSelectedParty(val === "ALL" ? null : val)
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Party" />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                     <Autocomplete
                  options={[{main_sect:"ALL"}].concat(itemTypes)}
                  getOptionLabel={(option) => option.main_sect}
                  value={selectedItemType}
                  onChange={(e, val) =>
                    setSelectedItemType(val)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Item Types"
                      size="small"
                      fullWidth
                    />
                  )}
                />
                  </Grid>
                  <Grid item xs={12} md={4}>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  sx={{ mt: { xs: 1.5, md: 0 } }}
                  fullWidth
                >
                  Submit
                </Button>
              </Grid>
              <Grid item xs={12} md={4}>
                {/* <Autocomplete
                  options={["ALL", ...paymentModes]}
                  getOptionLabel={(option) => option}
                  value={selectedMode || "ALL"}
                  onChange={(e, val) =>
                    setSelectedMode(val === "ALL" ? "" : val)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Payment Mode"
                      size="small"
                      fullWidth
                    />
                  )}
                /> */}
              </Grid>
               <Grid item xs={12} md={4}>
                {/* <Autocomplete
                  options={["Counter","Quotation"]}
                  getOptionLabel={(option) => option}
                  value={selectedType}
                  onChange={(e, val) =>
                    setSelectedType(val)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Type"
                      size="small"
                      fullWidth
                    />
                  )}
                /> */}
              </Grid>

           
            </Grid>
          </Box>

          <DataTable columns={columns} rows={reportData} />
          {/* {reportData?.length > 0 && (
            <Box mt={3} p={2} border="1px solid #ccc" borderRadius={2}>
              <Grid container spacing={2} justifyContent="flex-end">
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Total Sales: ₹
                    {reportData
                      .reduce((sum, row) => sum + Number(row.Total || 0), 0)
                      .toFixed(2)}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Total Credit: ₹
                    {reportData
                      .reduce((sum, row) => {
                        const total = Number(row.Total || 0);
                        const received = Number(row.Received || 0);
                        const credit = total - received;
                        // console.log(
                        //   `Row ${row.BillNo}: Total=${total}, Received=${received}, Credit=${credit}`
                        // );
                        return sum + credit;
                      }, 0)
                      .toFixed(2)}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Total Bank: ₹
                    {reportData
                      .filter((row) => row.PaymentMode === "Bank")
                      .reduce((sum, row) => sum + Number(row.Total || 0), 0)
                      .toFixed(2)}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          )} */}
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item xs={12} md={4}>
              <Button
                onClick={() => navigateToPrint("Sales Report")}
                variant="contained"
                color="primary"
                fullWidth
              >
                Print
              </Button>
            </Grid>
          </Grid>
        </DashboardCard>
      </PageContainer>
    </>
  );
}

export default DeliveryReport;
